import { render, staticRenderFns } from "./full_image.vue?vue&type=template&id=125fa7fd&scoped=true&"
import script from "./full_image.vue?vue&type=script&lang=js&"
export * from "./full_image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125fa7fd",
  null
  
)

export default component.exports